<svelte:options tag={null}/>
<script>
	import MediaQuery from "./MediaQuery.svelte";	
	import { BREAKPOINT_DESKTOP } from './breakpoints';
	let desktop_query = `(min-width: ${BREAKPOINT_DESKTOP})`
</script>

<MediaQuery query={desktop_query} let:matches>
	{#if matches}
	<slot />
	{/if}
</MediaQuery>